import {useQuery} from "@tanstack/react-query";


export function useGetEveryone() {
    const fetchURL = new URL(`${process.env.REACT_APP_KIOSK_SERVICE_URI}/getEveryone`)
    return useQuery({
        queryKey: ["getEveryone"],
        queryFn: () => fetch(fetchURL.toString()).then(response => response.json()).then(data => data.map((response) => ({label: response.name}))),
        placeholderData: [],
    })
}

export function useGetUser(username, isTeam, enabled = true) {
    return useQuery({
        queryKey: ['getUser', username, isTeam, enabled],
        queryFn: enabled ? async () => {

            const fetchURL = new URL(`${process.env.REACT_APP_KIOSK_SERVICE_URI}/getLifetimeRaised`)
            fetchURL.searchParams.set('username', username.toLowerCase());
            fetchURL.searchParams.set('team', `${isTeam}`);

            const res = await fetch(fetchURL.toString())
            return await res.json();
        } : null,
        enabled: enabled
    })
}

export function useGetClosest(total, enabled) {
    return useQuery({
        queryKey: ['getClosest', total],
        queryFn: async () => {
            const fetchURL = new URL(`${process.env.REACT_APP_KIOSK_SERVICE_URI}/getClosestTo`)
            fetchURL.searchParams.set('amount', total.toString())

            const res = await fetch(fetchURL.toString())
            return await res.json();
        },
        enabled
    })
}

export function useGTGMilestones(goal) {
    return useQuery({
        queryKey: ['getGTGMilestones', goal],
        queryFn: async () => {
            if (goal === null) return [];
            const fetchURL = new URL(`${process.env.REACT_APP_KIOSK_SERVICE_URI}/getGiftsThatGiveMilestones`)
            fetchURL.searchParams.set('goal', goal.toString())


            const res = await fetch(fetchURL.toString())
            return (await res.json()).map((gtg) => {
                return {
                    id: gtg.id,
                    amount: Number(gtg.value_rounded),
                    provide: gtg.provide_cover,
                    icon: gtg.icon,
                    description: gtg.description,
                };
            });
        }
    })
}